// @flow

/**
 * Returns an object containing only the keys and values from the first parameter
 * if there is a key associated with the second parameter.
 * It won't check if the values are equal, though, so be careful!
 *
 * @param {Object} first - this first object that will be intersected (only values from this object will be in the final object)
 * @param {Object} second - this second object that will be intersected
 * @return {Object}
 * Example usage: intersectKeys({ a:1, b:2 }, { b:2, c:3 }) // Returns { b: 2 }
 */
export default function intersectKeys(firstObj: Object, secondObj: Object) {
  if (typeof firstObj !== 'object') {
    throw new TypeError('Error calling intersectKeys: Object ' + firstObj + ' is not an object');
  }
  if (typeof secondObj !== 'object') {
    throw new TypeError('Error calling intersectKeys: Object ' + secondObj + ' is not an object');
  }

  const resultObj = {};
  Object.keys(firstObj).forEach((key) => {
    if (key in secondObj) {
      resultObj[key] = firstObj[key];
    }
  });
  return resultObj;
}
